import React from "react";

import { formatPhoneInput, phoneDigits } from "shared/lib/phoneNumber";

import { Input } from "./styles";

interface PhoneInputProps {
    // Наружу и внутрь номер ходит цифрами — маску примитив рисует сам.
    value: string;
    onChange: (digits: string) => void;
    id?: string;
    disabled?: boolean;
    autoFocus?: boolean;
    onSubmit?: () => void;
    className?: string;
}

export const PhoneInput = ({
    value,
    onChange,
    id,
    disabled,
    autoFocus,
    onSubmit,
    className,
}: PhoneInputProps) => {
    /*
    * ⚠️ Backspace на разделителе гасим руками. Поле управляемое, а маска строится из цифр:
    * удаление пробела цифр не меняет, React возвращает в DOM ту же строку — символ появляется
    * обратно, а каретка уезжает в конец. Поэтому на разделителе стираем цифру перед ним.
    * */
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            if (onSubmit) onSubmit();
            return;
        }

        if (event.key !== "Backspace") return;

        const input = event.currentTarget;
        const caret = input.selectionStart;

        if (caret === null || caret !== input.selectionEnd || caret === 0) return;
        if (/\d/.test(input.value[caret - 1])) return;

        event.preventDefault();

        const digitsBefore = phoneDigits(input.value.slice(0, caret));

        onChange(phoneDigits(digitsBefore.slice(0, -1) + input.value.slice(caret)));
    };

    return (
        <Input
            id={id}
            type="tel"
            inputMode="tel"
            autoComplete="tel"
            className={className}
            disabled={disabled}
            autoFocus={autoFocus}
            placeholder="+7 999 123 45 67"
            value={formatPhoneInput(value)}
            onChange={(event) => onChange(phoneDigits(event.target.value))}
            onKeyDown={handleKeyDown}
        />
    );
};
